var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookeditor"},[_c('button',{staticClass:"button save fa fa-floppy-o",attrs:{"id":"save2"},on:{"click":_vm.savecontent}}),_vm._v(" "),_c('pre',{attrs:{"contenteditable":"true","id":"contentHTML"},domProps:{"textContent":_vm._s(_vm.HTMLcontent)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdb010a8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/BookEdit_HTML.vue
// module id = 1070
// module chunks = 6